import { apiBaseUrl } from "./auth";
import { getStoredLanguage } from "../context/I18nContext";

const PROGRAMS_BASE = `${apiBaseUrl}/api/lessons/programs`;

async function request(
  path = "/",
  { accessToken, method = "GET", body, params } = {},
) {
  const lang = params?.lang || getStoredLanguage();
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Accept-Language": lang,
  };

  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }

  const queryParams = params ? { ...params, lang } : { lang };
  const queryString = `?${new URLSearchParams(queryParams).toString()}`;

  const response = await fetch(`${PROGRAMS_BASE}${path}${queryString}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  const isJson = response.headers
    .get("content-type")
    ?.includes("application/json");
  const payload = isJson ? await response.json() : {};

  if (!response.ok) {
    const message = payload.error || "Une erreur est survenue";
    const error = new Error(message);
    error.status = response.status;
    throw error;
  }

  return payload;
}

export function fetchPrograms({ accessToken, params } = {}) {
  return request("/", { accessToken, params });
}

export function createProgram(accessToken, payload) {
  return request("/", { accessToken, method: "POST", body: payload });
}

export function updateProgram(accessToken, programSlug, payload) {
  return request(`/${programSlug}/`, {
    accessToken,
    method: "PATCH",
    body: payload,
  });
}

export function deleteProgram(accessToken, programSlug) {
  return request(`/${programSlug}/`, { accessToken, method: "DELETE" });
}

export async function uploadTopicImage(accessToken, file) {
  if (!accessToken) {
    throw new Error("Unauthorized");
  }
  const formData = new FormData();
  formData.append("image", file);

  const response = await fetch(`${PROGRAMS_BASE}/topic-image/`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Accept-Language": getStoredLanguage(),
    },
    body: formData,
  });

  const isJson = response.headers
    .get("content-type")
    ?.includes("application/json");
  const payload = isJson ? await response.json() : {};

  if (!response.ok) {
    const message = payload.error || "Une erreur est survenue";
    const error = new Error(message);
    error.status = response.status;
    throw error;
  }

  return payload;
}

// Levels reuse the same upload endpoint as topics.
export function uploadLevelImage(accessToken, file) {
  return uploadTopicImage(accessToken, file);
}
